import { Link } from "react-router-dom";
import { formatHeat, getRankedTopics } from "@/utils/content";

const keywords = ["大结局口碑", "直播回应", "折叠屏定价", "夜跑活动", "加时绝杀", "AI 办公"];

export default function HomeHero() {
  const top3 = getRankedTopics("day").slice(0, 3);

  return (
    <section className="relative w-full overflow-hidden bg-foreground-950" aria-labelledby="hero-title">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20moody%20abstract%20background%20with%20deep%20charcoal%20tones%20and%20glowing%20coral%20red%20and%20amber%20gradient%20ribbons%2C%20soft%20film%20grain%20texture%2C%20dramatic%20cinematic%20lighting%2C%20minimal%20geometric%20composition%2C%20large%20dark%20negative%20space%20on%20the%20left%20for%20text%20overlay%2C%20no%20text%2C%20high%20detail&width=1600&height=900&seq=gua-hero-2026&orientation=landscape"
          alt="瓜田热榜首页背景 - 全网热议话题聚合"
          title="瓜田热榜 - 今日热门吃瓜榜"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/95 via-foreground-950/80 to-foreground-950/45" />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-transparent to-transparent" />
      </div>

      <div className="relative mx-auto w-full max-w-[1440px] px-4 py-16 md:px-8 md:py-24">
        <div className="grid w-full grid-cols-1 gap-10 lg:grid-cols-12 lg:items-center lg:gap-8">
          <div className="w-full lg:col-span-7">
            <p className="inline-flex items-center gap-2 rounded-full border border-background-50/20 bg-background-50/10 px-3 py-1.5 text-xs text-background-50/85">
              <span className="h-1.5 w-1.5 rounded-full bg-primary-400 animate-pulse-soft" />
              今日已收录 1,286 条全网热议话题
            </p>

            <h1
              id="hero-title"
              className="heading-font mt-5 text-3xl font-black leading-[1.15] text-background-50 md:text-5xl"
            >
              全网热门吃瓜榜，
              <br className="hidden sm:block" />
              在<span className="text-accent-400">瓜田热榜</span>一榜看尽
            </h1>

            <p className="mt-5 max-w-xl text-sm leading-relaxed text-background-50/75 md:text-base">
              实时汇总今日热门吃瓜榜、最近吃瓜热点盘点与全网热议事件合集。从娱乐八卦到社会焦点，
              把散落在各个平台的讨论整理成清晰的脉络，三分钟就能跟上今天在聊什么。
            </p>

            <div className="mt-8 flex w-full flex-col gap-3 sm:flex-row">
              <Link
                to="/rank"
                className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-fire-line text-base leading-none" aria-hidden="true" />
                </span>
                查看今日热榜
              </Link>
              <Link
                to="/#categories"
                className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/30 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:border-accent-300 hover:text-accent-200"
              >
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-layout-grid-line text-base leading-none" aria-hidden="true" />
                </span>
                按分类找话题
              </Link>
            </div>

            <div className="mt-8 flex flex-wrap items-center gap-x-3 gap-y-2">
              <span className="text-xs text-background-50/55">正在热议：</span>
              {keywords.map((word) => (
                <Link
                  key={word}
                  to="/rank"
                  className="cursor-pointer rounded-full border border-background-50/20 px-3 py-1 text-xs text-background-50/80 transition-colors hover:border-accent-300 hover:text-accent-200"
                >
                  #{word}
                </Link>
              ))}
            </div>
          </div>

          <div className="w-full lg:col-span-5">
            <div className="rounded-lg border border-background-50/15 bg-background-50/95 p-5 md:p-6">
              <div className="flex items-center justify-between">
                <h2 className="heading-font text-base font-bold text-foreground-950">此刻热榜 TOP3</h2>
                <span className="flex items-center gap-1 text-xs text-primary-600">
                  <span className="h-1.5 w-1.5 rounded-full bg-primary-500 animate-pulse-soft" />
                  实时
                </span>
              </div>
              <ol className="mt-4 flex flex-col gap-3">
                {top3.map((topic, index) => (
                  <li key={topic.id} className="flex items-start gap-3">
                    <span
                      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-md text-xs font-black ${
                        index === 0
                          ? "bg-primary-500 text-background-50"
                          : index === 1
                            ? "bg-primary-300 text-foreground-950"
                            : "bg-accent-400 text-foreground-950"
                      }`}
                    >
                      {index + 1}
                    </span>
                    <div className="min-w-0 flex-1">
                      <h3 className="text-sm font-semibold leading-snug text-foreground-900">
                        <Link
                          to={`/topic/${topic.id}`}
                          className="cursor-pointer transition-colors hover:text-primary-700"
                        >
                          {topic.title}
                        </Link>
                      </h3>
                      <p className="mt-1 flex items-center gap-1 text-xs text-foreground-500">
                        <span className="flex h-3.5 w-3.5 items-center justify-center">
                          <i className="ri-fire-line text-sm leading-none" aria-hidden="true" />
                        </span>
                        {formatHeat(topic.heat)} 热度
                      </p>
                    </div>
                  </li>
                ))}
              </ol>
              <Link
                to="/rank"
                className="mt-5 flex cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-foreground-950 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                看完整榜单
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-arrow-right-line text-base leading-none" aria-hidden="true" />
                </span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}